import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5f143afc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "title"
};
const _hoisted_2 = {
  key: 1,
  class: "des"
};
const _hoisted_3 = {
  class: "dot"
};
const _hoisted_4 = ["innerHTML"];
import { getStringFromCode } from "@/Tools";
export default /*#__PURE__*/_defineComponent({
  __name: 'DesItem',
  props: {
    data: {
      type: Object,
      default: () => {
        //list:[]
      }
    },
    islast: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["flex-col des-item", {
          islast: __props.islast
        }])
      }, [__props.data.title ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t(__props.data.title)), 1)) : _createCommentVNode("", true), __props.data.des ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t(__props.data.des)), 1)) : _createCommentVNode("", true), __props.data.list ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 2
      }, _renderList(__props.data.list, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          class: "des flex-row",
          key: i
        }, [_createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getStringFromCode)(i)), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t(item)), 1)]);
      }), 128)) : _createCommentVNode("", true), __props.data.html ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: "des",
        innerHTML: _ctx.$t(__props.data.html)
      }, null, 8, _hoisted_4)) : _createCommentVNode("", true)], 2);
    };
  }
});